/**
 * DpLayout — pathless layout for all /dp-* routes.
 * Theme and top-bar chrome are provided globally by App.js.
 */

import React from 'react';
import { Outlet } from 'react-router-dom';

function DpLayout() {
  return <Outlet />;
}

export default DpLayout;
